module.exports = __webpack_public_path__ + "static/img/icon.6767a6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_12/icon.jpg
// module id = JGD/
// module chunks = 0